import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { AnalyseExecutionResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useAnalyseExecutionMutation = (
  cb: (err: boolean, msg?: string) => void
) => {
  return useMutation<
    AnalyseExecutionResponse,
    AxiosError<any>,
    {
      executionId: number;
    }
  >(
    ({ executionId }) => {
      return axiosClient
        .post<AnalyseExecutionResponse>(
          `/execution/analyse`,
          {
            executionId,
          },
          {
            timeout: 10 * 60 * 1000, // 10 mins timeout
          }
        )
        .then(({ data }) => data);
    },
    {
      onError: () => {
        cb(true, "Cannot analyse execution. Please try again later.");
      },
      onSuccess: () => {
        cb(false);
      },
      retry: false,
    }
  );
};
